export const INIT_SPORT_DATA = "INIT_SPORT_DATA";
export const INIT_SPORT_DATA_COMPLETE = "INIT_SPORT_DATA_COMPLETE";
export const GET_RULE_SET_OPTIONS_COMPLETE = "GET_RULE_SET_OPTIONS_COMPLETE";
